export default __webpack_public_path__ + "static/media/crypt_preview_rev_1.fe6f7610.png";